import {
  loadAffiliateConfig,
  loadManifest,
  createAssetLoaderScript,
} from "../../utils/livechat-init-utils";

(async function () {
  try {
    window.LiveChat = window.LiveChat || {};
    window.LiveChat.manifest = window.LiveChat.manifest || {};
    const affiliateConfig = await loadAffiliateConfig();
    window.LiveChat = affiliateConfig;
    const manifest = await loadManifest(affiliateConfig.asset_manifest_filename);
    window.LiveChat!.manifest = manifest;

    await createAssetLoaderScript(manifest.asset_loader[0]);

  } catch (error) {
    (error as Error).message = `LIVECHAT ERROR: ${(error as Error).message}`;
    console.error(error);
    window.Sentry && window.Sentry.captureException(error);
  }
})();
